(ns frontend.ui.component.lp-portal.report.body.real-estate.holding.resi.pdf
  (:require
   [frontend.ui.component.lp-portal.column.pdf.view :as column]
   [frontend.ui.component.lp-portal.report.body.real-estate.holding.esg.pdf :as esg]
   [frontend.ui.page.lp-portal.report.pdf.view :as report]
   [frontend.ui.component.lp-portal.page.pdf.view :as page]
   [frontend.ui.component.lp-portal.card.pdf.view :as card]
   [potpuri.core :as potpuri]
   [frontend.ui.component.lp-portal.text-content.pdf.view :as text-content]
   [frontend.ui.component.chart.view :as chart-view]
   [frontend.ui.style.theme.core :as theme]
   [frontend.ui.component.lp-portal.table.pdf.view :as table]))

(defn overview-pages
  [report-data]
  [(page/page
    (page/third-column-background)
    (page/page-title {:page-title (:holding-name report-data) :toc-item true})
    (column/columns-2-to-1
     (column/column (card/card
                     "Case Overview"
                     (text-content/rich-content (->> report-data
                                                     :portfolio-summary-text
                                                     :rich-content))))
     {:margin [0 35 20 0]
      :stack  [(table/dynamic-stack (->> report-data
                                             :overview
                                             :figures))
               (text-content/optional-footer (->> report-data
                                                  :overview))]}))
   (page/page
    nil
    (page/page-title {:page-title (:holding-name report-data)})
    (column/columns
     (column/column (card/card
                     "Recent development"
                     (text-content/rich-content (->> report-data
                                                     :recent-development-text
                                                     :rich-content))))
     (column/column
      (card/card
       "Locations"
       {:svg   (chart-view/geomap-svg "highcharts"
                                      (potpuri/deep-merge
                                       (:figures (:map-data report-data))
                                       {:chart {:width  500
                                                :height 350}}))
        :width (- page/page-width-half 70)}
       (text-content/optional-footer (:map-data report-data))))))])

(defn overview-pages-stockholm-living
  [report-data]
  [(page/page
    (page/third-column-background)
    (page/page-title {:page-title (:holding-name report-data) :toc-item true})
    (column/columns-2-to-1
     (column/column (card/card
                     "Case Overview"
                     (text-content/rich-content (->> report-data
                                                     :portfolio-summary-text
                                                     :rich-content))))
     {:margin [0 35 20 0]
      :stack  [(table/dynamic-stack (->> report-data
                                             :overview
                                             :figures))
               (text-content/optional-footer (->> report-data
                                                  :overview))]}))])

(defn holding-pages
  [view-data]
  (concat (overview-pages view-data)
          (table/dynamic-table-pages {:page-title (:holding-name view-data)}
                                     nil
                                     (:portfolio-overview view-data)
                                     {:odd-color     (theme/color [:pdf :table :odd-color])
                                      :even-color    (theme/color [:pdf :table :even-color])
                                      :full-width?   true
                                      :heading-color (theme/color [:pdf :table
                                                                   :heading-color])})))

(defn holding-pages-stockholm-living
  [view-data]
  (concat (overview-pages-stockholm-living view-data)
          (table/dynamic-table-pages {:page-title (:holding-name view-data)}
                                     nil
                                     (:portfolio-overview view-data)
                                     {:odd-color     (theme/color [:pdf :table :odd-color])
                                      :even-color    (theme/color [:pdf :table :even-color])
                                      :full-width?   true
                                      :heading-color (theme/color [:pdf :table
                                                                   :heading-color])})
          (esg/esg-pages view-data)))

(defn holding-pages-property-esg
  [view-data]
  (concat (holding-pages view-data)
          (esg/esg-pages view-data)))

(defn holding-pages-portfolio-esg
  [view-data]
  (concat (holding-pages view-data)
          (esg/portfolio-esg-pages view-data)))

(defn pdf-report
  [{:keys [reporting-period reference-date] :as view-data}]
  (report/report view-data
                 (holding-pages view-data)
                 "PE holding company"
                 reporting-period
                 reference-date))
